module.exports = __webpack_public_path__ + "26dd8b2be94932b19c11811dc3391b12.svg";